import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ProSidebarProvider } from "react-pro-sidebar";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ErrorBoundary from "./ErrorBoundary";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const root = ReactDOM.createRoot(document.getElementById("root"));
const listOfCodeToNotRepeat = [500, 404];



const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			retry: (_, error) => !listOfCodeToNotRepeat.includes(error?.cause),

		},
	},
});

root.render(
	<React.StrictMode>
		<ProSidebarProvider>

			<QueryClientProvider client={queryClient}>
				<ErrorBoundary>
					<App />
				</ErrorBoundary>
				{/* <ReactQueryDevtools /> */}
			</QueryClientProvider>
		</ProSidebarProvider>

	</React.StrictMode>
);
